import * as React from 'react';

import MetricsReview56 from './MetricsReview56';

export const metricsReview56 = () => <MetricsReview56 />;

export default {
    title: 'Illustration/MetricsReview56',
    component: MetricsReview56,
    parameters: {
        notes: "`import MetricsReview56 from 'box-ui-elements/es/illustration/MetricsReview56';`",
    },
};
